import React from "react";
import PropTypes from "prop-types";
import { Scrollbars } from "react-custom-scrollbars";
import { isFunction, get } from "lodash";
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon/Icon";
import { withResizeDetectWrapper } from "@configuratorware/configurator-frontendgui/Shared/HOCs/ResizeDetect/ResizeDetect";
import { Typography } from "@material-ui/core";
import clsx from "clsx";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button/Button";
import { ArrowLeftIcon, ArrowRightIcon } from "../../../../../Icons";

export const styles = (theme) => ({
  scrollWrapper: {
    "&:hover, &:active, &:focus": {
      background: "#C9C9C9",
    },
    height: 38,
    width: 38,
    [theme.breakpoints.up("sm")]: {
      height: 34,
      width: 34,
      marginTop: -6,
    },
    borderRadius: 100,
    marginTop: -3,
  },
  arrowScrollIcon: {
    "&:hover": {
      cursor: "pointer",
      fontWeight: "bold",
    },
    maxHeight: 50,
    minHeight: 50,
    fontSize: 50,
    marginTop: -10,
    [theme.breakpoints.up("sm")]: {
      maxHeight: 50,
      minHeight: 50,
      fontSize: 50,
      marginTop: -14,
    },
  },
  dots: {
    position: "inherit",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    maxHeight: 32,
    minHeight: 32,
    [theme.breakpoints.up("sm")]: {
      maxHeight: 21,
      minHeight: 21,
    },
    width: "100%",
    flexWrap: "wrap",
    overflow: "visible",
  },
  dotContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxHeight: 32,
    minHeight: 32,
    margin: "0px 8px",
    [theme.breakpoints.up("sm")]: {
      maxHeight: 21,
      minHeight: 21,
      margin: "0px 7px",
    },
    "&.wrap-container": {
      maxHeight: 32,
      minHeight: 32,
      [theme.breakpoints.up("sm")]: {
        maxHeight: 21,
        minHeight: 21,
      },
      "& > div": {
        margin: 0,
      },
    },
    "& > div": {
      cursor: "pointer",
      height: 15,
      width: 15,
      minHeight: 15,
      minWidth: 15,
      borderRadius: "50%",
      transition: "background-color 0.1s ease",
    },
    "&:last-child": {
      marginRight: 0,
    },
  },
  inactiveDotMode: {
    backgroundColor: "transparent",
    height: "7.2px !important",
    width: "7.2px !important",
    minHeight: "7px !important",
    minWidth: "7px !important",
    [theme.breakpoints.up("sm")]: {
      height: "5.2px !important",
      width: "5.2px !important",
      minHeight: "5px !important",
      minWidth: "5px !important",
    },

    border: "1px solid black",
  },
  activeDotMode: {
    backgroundColor: theme.palette.primary.dark,
    border: "1px solid black",

    height: 15,
    width: 15,
  },
  arrowDisabled: {
    color: "grey",
  },

  arrowButton: {
    top: -2,
    height: 38,
    width: 38,

    [theme.breakpoints.up("sm")]: {
      "&  .first": {
        // marginLeft: 7
      },
      height: 34,
      width: 34,
      top: -5,
    },
    borderRadius: 100,
    minWidth: 0,

    "&:hover, &:active, &:focus": {
      background: "#C9C9C9",
    },
  },
});

class Thumbnail extends React.Component {
  static propTypes = {
    thumbnails: PropTypes.object,
    size: PropTypes.object,
    thumbnailChange: PropTypes.func,
    selectedDesignViewIdentifier: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    classes: PropTypes.object,
    onThumbnailClick: PropTypes.func,
    previewOpen: PropTypes.bool,
    width: PropTypes.string,
    scrollbarHeight: PropTypes.number,
  };

  state = {
    isScrollingAvailable: true,
    availableWidth: 0,
    hover: null,
    touch: null,
  };

  onThumbnailClick = (thumbnails, thumbnail) => () => {
    if (isFunction(this.props.thumbnailChange)) {
      this.props.thumbnailChange(
        thumbnails,
        thumbnail.thumbnailImage,
        !thumbnail.active
      );
    }
  };

  // Sehr redundant, aber keine großen einbusen in der Zeit :P
  handleClickLeftArrowDots() {
    let selectedIdentifier = this.props.selectedDesignViewIdentifier;
    if (!selectedIdentifier)
      selectedIdentifier = this.props.thumbnails.items[0].identifier;
    const idx = this.props.thumbnails.items.findIndex(
      (item) => selectedIdentifier === item.identifier
    );
    if (idx < 1)
      this.props.onThumbnailClick(
        this.props.thumbnails.items[this.props.thumbnails.items.length - 1]
          .identifier
      );
    else
      this.props.onThumbnailClick(
        this.props.thumbnails.items[idx - 1].identifier
      );
  }

  handleClickRightArrowDots() {
    let selectedIdentifier = this.props.selectedDesignViewIdentifier;
    if (!selectedIdentifier)
      selectedIdentifier = this.props.thumbnails.items[0].identifier;
    const idx = this.props.thumbnails.items.findIndex(
      (item) => selectedIdentifier === item.identifier
    );
    if (idx >= this.props.thumbnails.items.length - 1 && idx > -1)
      this.props.onThumbnailClick(this.props.thumbnails.items[0].identifier);
    else
      this.props.onThumbnailClick(
        this.props.thumbnails.items[idx + 1].identifier
      );
  }

  onHover = (which) => {
    this.setState({ hover: which });
    if (which === null) {
      this.setState({ touch: null });
    }
  };

  onTouch = (which) => {
    this.setState({ touch: which });
  };

  render() {
    const {
      thumbnails,
      selectedDesignViewIdentifier,
      classes,
      onThumbnailClick,
      width,
    } = this.props;

    const { isScrollingAvailable, hover, touch } = this.state;

    const { items } = thumbnails;
    const isSmallScreen = !isWidthUp("md", width);

    if (items && items.length <= 1) {
      return null;
    }
    let selectedIdentifier = selectedDesignViewIdentifier;
    if (!selectedIdentifier) selectedIdentifier = items[0].identifier;
    return (
      <>
        <div className={classes.dots}>
          {isScrollingAvailable && (
            <ArrowLeftIcon
              onClick={this.handleClickLeftArrowDots.bind(this)}
              className={clsx(classes.arrowScrollIcon, "first")}
              onHover={hover === "left"}
              onPressed={touch === "left"}
              onMouseEnter={() => this.onHover("left")}
              onMouseLeave={() => this.onHover(null)}
              onTouchStart={() => this.onTouch("left")}
              onTouchLeave={() => this.onTouch(null)}
              onMouseDown={() => this.onTouch("left")}
              onMouseUp={() => this.onTouch(null)}
            >
              arrow_back
            </ArrowLeftIcon>
          )}
          {items &&
            items.map((thumbnail, index) => (
              <div
                className={`${classes.dotContainer} ${
                  selectedIdentifier === thumbnail.identifier ? "active" : ""
                } ${isSmallScreen ? "wrap-container" : ""}`}
                key={thumbnail.identifier}
              >
                <Typography
                  component="div"
                  className={
                    selectedIdentifier === thumbnail.identifier
                      ? classes.activeDotMode
                      : classes.inactiveDotMode
                  }
                  onClick={() => onThumbnailClick(thumbnail.identifier)}
                />
              </div>
            ))}
          {isScrollingAvailable && (
            <ArrowRightIcon
              onClick={this.handleClickRightArrowDots.bind(this)}
              className={clsx(classes.arrowScrollIcon)}
              onHover={hover === "right"}
              onPressed={touch === "right"}
              onMouseEnter={() => this.onHover("right")}
              onMouseLeave={() => this.onHover(null)}
              onTouchStart={() => this.onTouch("right")}
              onTouchLeave={() => this.onTouch(null)}
              onMouseDown={() => this.onTouch("right")}
              onMouseUp={() => this.onTouch(null)}
            >
              arrow_forward
            </ArrowRightIcon>
          )}
        </div>
      </>
    );
  }
}

const VariantCarouselWithResizeDetectWrapper = withResizeDetectWrapper(
  withWidth({ initialWidth: "lg" })(Thumbnail)
);

export default withStyles(styles, { name: "Thumbnail" })((props) => (
  <VariantCarouselWithResizeDetectWrapper
    wrapperClassName={props.classes.resizeDetectWrapper}
    {...props}
  />
));
